import { render, staticRenderFns } from "./SubclientsTable.vue?vue&type=template&id=c9af2370&scoped=true"
import script from "./SubclientsTable.vue?vue&type=script&lang=ts"
export * from "./SubclientsTable.vue?vue&type=script&lang=ts"
import style0 from "./SubclientsTable.vue?vue&type=style&index=0&id=c9af2370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9af2370",
  null
  
)

export default component.exports